import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import ModuleList from '../components/ModuleList';
import { content } from '../api/client';

const ModuleIndex = () => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    content.modules()
      .then(({ data }) => setModules(data))
      .catch(() => setError('Failed to load modules'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <CircularProgress sx={{ m: 4 }} />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography variant="h4" gutterBottom>
        Welcome to the Code Hub
      </Typography>
      <Typography paragraph>
        Welcome! You’ve just stepped into your personal training ground for learning how to code. Whether you’re completely new to programming or just brushing up on the basics, this space was built to help you grow confidently and comfortably. Through interactive lessons, visual examples, and beginner-friendly guidance, you’ll learn how to read, write, and understand code — one step at a time.
      </Typography>
      <Typography paragraph>
        Choose a module to get started. Each one is focused on a different area of coding — from building web pages with HTML to analyzing data with Python or R. You’ll find short, clear lessons grouped into courses, each with hands-on examples and tools to try out what you've learned. No experience necessary — just curiosity, and maybe a sense of adventure.
      </Typography>

     <Typography variant="h4" gutterBottom>
        Select a Module
      </Typography>
      <ModuleList modules={modules} />
    </Box>
  );
};

export default ModuleIndex;
